/* eslint-disable max-len */
export const helpStepCUIT = [
    {
        title: "Residente Fiscal en el Exterior",
        description:
            "La Ley sobre el Cumplimiento Fiscal relativa a Cuentas en el Extranjero (FATCA) es un régimen amplio y puede impactar a cualquier persona natural o jurídica, estadounidense o extranjera, en la medida que esa persona esté involucrada en la realización o recepción de pagos que encuadren dentro del ámbito de Ciudadano, Residente legal, Residente tributario, empresa, sucesión o fideicomiso de los EE.UU.",
    },
    {
        title: "Fecha de inscripción registral",
        description:
            "Es la fecha en la que realizaste la inscripción de tu empresa ante el organismo de control. En caso de que no recuerdes la fecha la pódes encontrar en el inicio del estatuto como Fecha de inscripcion de tu empresa, o puedes buscarla ingresando a https://www.argentina.gob.ar/justicia/registro-nacional-sociedades",
    },
    {
        title: "Ente regulador",
        description:
            "Es el organismo estatal donde desarrollaste al inscripción de tu empresa, estas se encargan de controlar que funcionen correctamente los servicios públicos a cargo de empresas Privadas. En Argentina (IGJ,Registro Público de comercio,CNV,ETC).",
    },
    {
        title: "Sujeto Obligado",
        description:
            "Los Sujetos Obligados son las personas humanas y jurídicas determinadas en el artículo 20 de la Ley N°​ 25.246 y modificatorias. Cada uno de ellos está regulado por una resolución específica que rige su actividad. Para conocer si eres Sujeto Obligado consulta en https://sro.uif.gob.ar/SROAPP/#/consultaRegistracion",
    },
    {
        title: "Domicilio fiscal",
        description:
            "Es el lugar donde se localiza al obligado tributario, ya sea persona física o jurídica, en sus relaciones con la Administración, se debe consignar no sólo al momento de su inscripción sino que deben incorporarlo además en sus declaraciones juradas, formularios o en los escritos que presenten ante la Administración local.",
    },
    {
        title: "Domicilio legal",
        description:
            "Sede donde la empresa desarrolla su actividad principal y administrativa,señalado expresamente en el estatuto o contratos sociales.",
    },
];

export default helpStepCUIT;
